import { LIST_BODY } from "@/apollo/queries/md";
import gql from "graphql-tag";
export const UPDATE_MD_UPDATES_VISTOS = gql`
  mutation UpdateVistoActualizacion(
    $id_actualizacion: Int!
    $id_modulo: Int!
    $id_tipo: Int!
  ) {
    UpdateVistoActualizacion(
      id_actualizacion: $id_actualizacion
      id_modulo: $id_modulo
      id_tipo: $id_tipo
    ) {
      id_actualizacion
      confirm_visto
    }
  }
`;
export const SAVE_CHANNEL_LAYOUT = gql`
  mutation SaveListaReproduccion(
    $id_canal: Int!
    $lista: CanalListaObjectNewUpdatedCurrent!
  ) {
    SaveListaReproduccion(id_canal: $id_canal, lista: $lista) ${LIST_BODY}
  }
`;

export const EDIT_CHANNEL_LAYOUT = gql`
  mutation UpdateListaReproduccion(
    $id_canal: Int!
    $lista: CanalListaObjectNewUpdatedCurrent!
  ) {
    UpdateListaReproduccion(id_canal: $id_canal, lista: $lista) ${LIST_BODY}
  }
`;
